export const selectShowMatchingSetPreview = (state) => state.fabricDesign.showMatchingSetPreview;
